import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBetMulti = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.375,
	height: 22.594,
	viewBox: "0 0 18.375 22.594",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Bet Multi",
		transform: "translate(0 0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5542",
				d: "M17.625,21.844V2.157A1.407,1.407,0,0,0,16.219.75H2.156A1.407,1.407,0,0,0,.75,2.157V21.844l4.812-2.813,3.625,2.813,3.626-2.813Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5543",
				d: "M5.3,9.891a.352.352,0,1,1,0-.7",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5544",
				d: "M5.3,9.891a.352.352,0,1,0,0-.7",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5545",
				d: "M5.3,14.109a.352.352,0,1,1,0-.7",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5546",
				d: "M5.3,14.109a.352.352,0,1,0,0-.7",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5547",
				d: "M5.3,5.672a.352.352,0,1,1,0-.7",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 5548",
				d: "M5.3,5.672a.352.352,0,1,0,0-.7",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				"data-name": "Line 957",
				x2: 4.836,
				transform: "translate(8.915 5.32)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				"data-name": "Line 958",
				x2: 4.836,
				transform: "translate(8.915 9.539)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("line", {
				"data-name": "Line 959",
				x2: 4.836,
				transform: "translate(8.915 13.758)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	})
});
export { SvgBetMulti as ReactComponent };
